class OverviewFilters {
    constructor(config) {
        this.config = Object.assign({
            scope: '[data-overview-filter="scope"]'
        }, config);

        this.$scope = $(this.config.scope);

        if (this.$scope.length > 0) {
            this.init();
        }
    }

    init() {
        this.addEventListeners();
    }

    addEventListeners() {
        this.scroll == false;
        let observer = new ResizeObserver(this.onResize.bind(this))
        this.$scope.each((index, scope) => {
            observer.observe(scope);
        });
    }

    onResize(entries) {
        this.observerTimeout ? clearTimeout(this.observerTimeout) : null;
        this.observerTimeout = setTimeout(() => {
            for (let index in entries) {
                let entry = entries[index];
                let $scope = $(entry.target);
                let removed = this.removeSticky($scope);

                if (!removed || !this.scroll) {
                    this.scroll = true;
                    return
                }

                $([document.documentElement, document.body]).animate({
                    scrollTop: $scope.offset().top - this.getTop()
                }, 250);

            }
        }, 200);
    }

    removeSticky($scope) {
        if (!$scope.hasClass('position-sticky')) {
            return false;
        }

        let top = this.getTop();
        if ($(window).height() >= ($scope.outerHeight() + top)) {
            return false;
        }
        $scope.removeClass('position-sticky');
        return true;
    }

    getTop() {
        return 150;
    }
}

new OverviewFilters();
